// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"login_loginForm__hU7Pw","title":"login_title__1aTxz","wrapper":"login_wrapper__2SRHZ"};